module.exports = __webpack_public_path__ + "static/media/4050.dabe11a8.jpg";